/**
 * @fileoverview POST handler for the "/engagement/landing_pages/:app_group_id/custom_subdomain/reactivate" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPagesAppGroupIdCustomSubdomainReactivateCacheKeys } from "./constants";
import type {
  PostEngagementLandingPagesAppGroupIdCustomSubdomainReactivateProps,
  PostLandingPagesCustomSubdomainReactivateResult,
} from "./types";

export const postLandingPagesCustomSubdomainReactivate = reactQueryMutationAdapter(
  engagementLandingPagesAppGroupIdCustomSubdomainReactivateCacheKeys,
  (
    props: PostEngagementLandingPagesAppGroupIdCustomSubdomainReactivateProps
  ): Promise<PostLandingPagesCustomSubdomainReactivateResult> => {
    return fetch(
      `/engagement/landing_pages/${props.appGroupId}/custom_subdomain/reactivate`,
      "POST",
      props,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
